import React, { forwardRef } from "react";
// Datos fijos del remitente para la guía de envío — distintos a los de
// Factura.jsx (esos son los datos fiscales para AFIP; estos son los que
// Finca Los Astros usa realmente para el despacho de bultos).
const datosRemitente = {
razonSocial: "Finca Los Astros S.A.S",
cuit: "30-71934761-0",
domicilio: ["Servidumbre de tránsito sin num. fracc. C,", "El Peral (5561) Mendoza"],
contacto: "lprezzavento@fincalosastros.com / +54 9 261 2528 739",
};
const nombreDestinatario = (cliente) => {
if (!cliente) return "-";
return cliente.personeria === "persona fisica"
? `${cliente.nombre || ""} ${cliente.apellido || ""}`.trim() || "-"
: cliente.razonSocial || "-";
};
// Domicilio de ENTREGA de la venta (venta.direccionEntrega) — no el
// domicilio fiscal del cliente: pueden diferir (ej. un regalo que se manda
// a otra dirección). Ver direccionEntregaVenta en VentasForm.js.
const domicilioTexto = (direccion) => {
if (!direccion) return "-";
const linea1 = [direccion.calle, direccion.altura].filter(Boolean).join(" ");
const piso = [direccion.piso, direccion.unidad].filter(Boolean).join(" ");
const parte1 = [linea1, piso].filter(Boolean).join(" piso ");
const parte2 = [direccion.codigoPostal].filter(Boolean).join(" ");
const parte3 = [direccion.ciudad, direccion.pais].filter(Boolean).join(", ");
return [parte1, parte2, parte3].filter(Boolean).join(" , ") || "-";
};
const documentoDestinatario = (cliente) => {
if (!cliente) return "-";
return cliente.personeria === "persona fisica"
? cliente.numeroDeDocumento || "-"
: cliente.cuit || "-";
};
// marginTop distinto en la primera fila (5px) vs el resto (15px) — layout
// aprobado a mano en preview_guia.html.
const Fila = ({ label, children, primera = false }) => (
<div style={{ display: "flex", marginTop: primera ? "5px" : "15px", gap: "30px" }}>
<div style={{ width: "150px", flexShrink: 0, fontWeight: "bold" }}>{label}:</div>
<div style={{ flexGrow: 1 }}>{children}</div>
</div>
);
// Una guía por bulto — bultoNumero/cantidadBultos arman el "Bulto N°" de
// abajo. Igual patrón que Factura/Remito: forwardRef + html2canvas/jsPDF,
// una página por componente (ver Ventas.js, botón Imprimir de la pestaña
// Envíos). Cada página del PDF final es media hoja A4 vertical (210 x
// 148.5mm, ver generación en Ventas.js) — no una A4 entera por bulto.
// Estilos ajustados y aprobados a mano sobre preview_guia.html.
const GuiaEnvio = forwardRef(({ cliente, direccionEntrega, empresaTransporte, observaciones, despachadoPor, cantidadBultos, bultoNumero }, ref) => {
return (
<div
ref={ref}
style={{
width: "210mm",
height: "148.5mm",
padding: "8mm 12mm",
background: "#fff",
fontFamily: "'Courier New', monospace",
color: "#000",
margin: "0 auto",
boxSizing: "border-box",
fontSize: "13px",
display: "flex",
flexDirection: "column",
}}
>
<div style={{ textAlign: "center" }}>
<h1 style={{ fontSize: "24px", letterSpacing: "3px", margin: "0 0 0px" }}>GUÍA DE ENVÍO</h1>
<p style={{ fontWeight: "bold", fontSize: "13px", margin: "2px 0 0" }}>{datosRemitente.razonSocial}</p>
<p style={{ margin: "2px 0" }}>CUIT: {datosRemitente.cuit}</p>
<p style={{ margin: "0" }}>{datosRemitente.domicilio[0]}</p>
<p style={{ margin: "0 0 2px" }}>{datosRemitente.domicilio[1]}</p>
<p style={{ margin: "2px 0 0" }}>{datosRemitente.contacto}</p>
</div>
<hr style={{ border: "none", borderTop: "1px solid #9d9d9d", margin: "15px 0" }} />
<Fila label="DESTINATARIO/A" primera>{nombreDestinatario(cliente)}</Fila>
<Fila label="DOMICILIO">{domicilioTexto(direccionEntrega)}</Fila>
<Fila label="CUIT / CUIL / DNI">{documentoDestinatario(cliente)}</Fila>
<Fila label="NUM. DE TELÉFONO">{cliente?.telefono || "-"}</Fila>
<Fila label="OBSERVACIONES">
<div style={{ whiteSpace: "pre-wrap" }}>{observaciones || "-"}</div>
</Fila>
<Fila label="DESPACHADO POR">{despachadoPor || "-"}</Fila>
<hr style={{ border: "none", borderTop: "1px solid #9d9d9d", margin: "15px 0 0" }} />
<div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px", textAlign: "center" }}>
<div style={{ flex: 1 }}>
<p style={{ fontSize: "13px", fontWeight: "bold", margin: "0 0 24px" }}>CANTIDAD DE BULTOS</p>
<div style={{ height: "48px", display: "flex", alignItems: "center", justifyContent: "center" }}>
<p style={{ fontSize: "60px", fontWeight: "normal", lineHeight: "48px", margin: "0" }}>{cantidadBultos || 0}</p>
</div>
</div>
<div style={{ flex: 1 }}>
<p style={{ fontSize: "13px", fontWeight: "bold", margin: "0 0 24px" }}>BULTO N°</p>
<div style={{ height: "48px", display: "flex", alignItems: "center", justifyContent: "center" }}>
<p style={{ fontSize: "60px", fontWeight: "normal", lineHeight: "48px", margin: "0" }}>{bultoNumero || 1}</p>
</div>
</div>
<div style={{ flex: 1 }}>
<p style={{ fontSize: "13px", fontWeight: "bold", margin: "0 0 24px" }}>ENVIADO POR:</p>
<div style={{ height: "48px", display: "flex", alignItems: "center", justifyContent: "center" }}>
<p style={{ fontSize: "13px", fontWeight: "bold", lineHeight: "16px", margin: "0", maxWidth: "95%" }}>{empresaTransporte || "-"}</p>
</div>
</div>
</div>
</div>
);
});
export default GuiaEnvio;
